import { Box, Flex, Heading, Text, Link, Spacer } from "@chakra-ui/react";
import { FooterInfo } from "../../layouts/Footer";
import { LandingHeader } from "../../layouts/Header";

export function Privacy() {
    return (
        <Flex flexDirection="column" height="100vh">
            <Box width="full" position="sticky" top="0" zIndex="sticky">
                <LandingHeader />
            </Box>
            <Box as="main" flex="1">
                <Box width="80%" mx="auto">
                    <Heading as="h1" my={3}>
                        Datenschutz­erklärung
                    </Heading>
                    <Spacer my={20} />
                    <Heading as="h2" my={3}>
                        1. Datenschutz auf einen Blick
                    </Heading>
                    <Heading as="h3" my={3}>
                        Allgemeine Hinweise
                    </Heading>{" "}
                    <Text>
                        Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese
                        Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können. Ausführliche
                        Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgeführten Datenschutzerklärung.
                    </Text>
                    <Heading as="h3" my={3}>
                        Datenerfassung auf dieser Website
                    </Heading>{" "}
                    <Heading as="h4" my={3}>
                        Wer ist verantwortlich für die Datenerfassung auf dieser Website?
                    </Heading>{" "}
                    <Text>
                        Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Abschnitt
                        „Hinweis zur Verantwortlichen Stelle“ in dieser Datenschutzerklärung entnehmen.
                    </Text>{" "}
                    <Heading as="h4" my={3}>
                        Wie erfassen wir Ihre Daten?
                    </Heading>{" "}
                    <Text>
                        Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.&nbsp;B. um Daten handeln,
                        die Sie in ein Kontaktformular eingeben.
                    </Text>{" "}
                    <Text>
                        Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind
                        vor allem technische Daten (z.&nbsp;B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung dieser
                        Daten erfolgt automatisch, sobald Sie diese Website betreten.
                    </Text>{" "}
                    <Heading as="h4" my={3}>
                        Wofür nutzen wir Ihre Daten?
                    </Heading>{" "}
                    <Text>
                        Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können zur
                        Analyse Ihres Nutzerverhaltens verwendet werden.
                    </Text>{" "}
                    <Heading as="h4" my={3}>
                        Welche Rechte haben Sie bezüglich Ihrer Daten?
                    </Heading>
                    <Text>
                        Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen
                        Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen. Wenn Sie eine
                        Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese Einwilligung jederzeit für die Zukunft widerrufen. Außerdem
                        haben Sie das Recht, unter bestimmten Umständen die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
                        Des Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
                    </Text>{" "}
                    <Text>Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit an uns wenden.</Text>
                    <Spacer my={20} />
                    <Heading as="h2" my={3}>
                        2. Hosting
                    </Heading>
                    <Text>Wir hosten die Inhalte unserer Website bei folgenden Anbietern:</Text>
                    <Heading as="h3" my={3}>
                        Hetzner
                    </Heading>{" "}
                    <Text>Anbieter ist die Hetzner Online GmbH, Industriestr. 25, 91710 Gunzenhausen (nachfolgend Hetzner).</Text>{" "}
                    <Text>
                        Details entnehmen Sie der Datenschutzerklärung von Hetzner:{" "}
                        <Link
                            href="https://www.hetzner.com/de/rechtliches/datenschutz"
                            target='_blank'
                            rel='noopener noreferrer'>
                            https://www.hetzner.com/de/rechtliches/datenschutz
                        </Link>
                        .
                    </Text>{" "}
                    <Text>
                        Die Verwendung von Hetzner erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Wir haben ein berechtigtes Interesse an einer
                        möglichst zuverlässigen Darstellung unserer Website. Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die
                        Verarbeitung ausschließlich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1 TDDDG, soweit die Einwilligung die
                        Speicherung von Cookies oder den Zugriff auf Informationen im Endgerät des Nutzers (z.&nbsp;B. Device-Fingerprinting) im Sinne
                        des TDDDG umfasst. Die Einwilligung ist jederzeit widerrufbar.
                    </Text>
                    <Heading as="h4" my={3}>
                        Auftragsverarbeitung
                    </Heading>{" "}
                    <Text>
                        Wir haben einen Vertrag über Auftragsverarbeitung (AVV) zur Nutzung des oben genannten Dienstes geschlossen. Hierbei handelt
                        es sich um einen datenschutzrechtlich vorgeschriebenen Vertrag, der gewährleistet, dass dieser die personenbezogenen Daten
                        unserer Websitebesucher nur nach unseren Weisungen und unter Einhaltung der DSGVO verarbeitet.
                    </Text>
                    <Heading as="h3" my={3}>
                        Externes Hosting
                    </Heading>{" "}
                    <Text>
                        Diese Website wird extern gehostet. Die personenbezogenen Daten, die auf dieser Website erfasst werden, werden auf den Servern
                        des Hosters / der Hoster gespeichert. Hierbei kann es sich v.&nbsp;a. um IP-Adressen, Kontaktanfragen, Meta- und
                        Kommunikationsdaten, Vertragsdaten, Kontaktdaten, Namen, Websitezugriffe und sonstige Daten, die über eine Website generiert
                        werden, handeln.
                    </Text>{" "}
                    <Text>
                        Das externe Hosting erfolgt zum Zwecke der Vertragserfüllung gegenüber unseren potenziellen und bestehenden Kunden (Art. 6
                        Abs. 1 lit. b DSGVO) und im Interesse einer sicheren, schnellen und effizienten Bereitstellung unseres Online-Angebots durch
                        einen professionellen Anbieter (Art. 6 Abs. 1 lit. f DSGVO). Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt
                        die Verarbeitung ausschließlich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1 TDDDG, soweit die Einwilligung
                        die Speicherung von Cookies oder den Zugriff auf Informationen im Endgerät des Nutzers (z.&nbsp;B. Device-Fingerprinting) im
                        Sinne des TDDDG umfasst. Die Einwilligung ist jederzeit widerrufbar.
                    </Text>{" "}
                    <Text>
                        Unser(e) Hoster wird bzw. werden Ihre Daten nur insoweit verarbeiten, wie dies zur Erfüllung seiner Leistungspflichten
                        erforderlich ist und unsere Weisungen in Bezug auf diese Daten befolgen.
                    </Text>{" "}
                    <Text>Wir setzen folgende(n) Hoster ein:</Text>
                    <Text>
                        netcup GmbH
                        <br />
                        Daimlerstraße 25
                        <br />
                        D-76185 Karlsruhe
                    </Text>
                    <Heading as="h4" my={3}>
                        Auftragsverarbeitung
                    </Heading>{" "}
                    <Text>
                        Wir haben einen Vertrag über Auftragsverarbeitung (AVV) zur Nutzung des oben genannten Dienstes geschlossen. Hierbei handelt
                        es sich um einen datenschutzrechtlich vorgeschriebenen Vertrag, der gewährleistet, dass dieser die personenbezogenen Daten
                        unserer Websitebesucher nur nach unseren Weisungen und unter Einhaltung der DSGVO verarbeitet.
                    </Text>
                    <Spacer my={20} />
                    <Heading as="h2" my={3}>
                        3. Allgemeine Hinweise und Pflicht­informationen
                    </Heading>
                    <Heading as="h3" my={3}>
                        Datenschutz
                    </Heading>{" "}
                    <Text>
                        Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten
                        vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
                    </Text>{" "}
                    <Text>
                        Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. Personenbezogene Daten sind Daten, mit
                        denen Sie persönlich identifiziert werden können. Die vorliegende Datenschutzerklärung erläutert, welche Daten wir erheben und
                        wofür wir sie nutzen. Sie erläutert auch, wie und zu welchem Zweck das geschieht.
                    </Text>{" "}
                    <Text>
                        Wir weisen darauf hin, dass die Datenübertragung im Internet (z.&nbsp;B. bei der Kommunikation per E-Mail) Sicherheitslücken
                        aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.
                    </Text>
                    <Heading as="h3" my={3}>
                        Hinweis zur verantwortlichen Stelle
                    </Heading>{" "}
                    <Text>Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:</Text>{" "}
                    <Text>
                        Cedric Klimt
                        <br />
                        Johannes-Rebmann Straße 12
                        <br />
                        70839 Gerlingen
                        <br />
                        Deutschland
                    </Text>
                    <Text>
                        {/*
                        Telefon: [Telefonnummer der verantwortlichen Stelle]
                        <br />
                        */}
                        E-Mail: contact@labchron.com
                    </Text>
                    <Text>
                        Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit anderen über die Zwecke und
                        Mittel der Verarbeitung von personenbezogenen Daten (z.&nbsp;B. Namen, E-Mail- Adressen o. Ä.) entscheidet.
                    </Text>
                    <Heading as="h3" my={3}>
                        Speicherdauer
                    </Heading>{" "}
                    <Text>
                        Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen
                        Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt. Wenn Sie ein berechtigtes Löschersuchen geltend machen oder
                        eine Einwilligung zur Datenverarbeitung widerrufen, werden Ihre Daten gelöscht, sofern wir keine anderen rechtlich zulässigen
                        Gründe für die Speicherung Ihrer personenbezogenen Daten haben (z.&nbsp;B. steuer- oder handelsrechtliche
                        Aufbewahrungsfristen); im letztgenannten Fall erfolgt die Löschung nach Fortfall dieser Gründe.
                    </Text>
                    <Heading as="h3" my={3}>
                        Allgemeine Hinweise zu den Rechtsgrundlagen der Datenverarbeitung auf dieser Website
                    </Heading>{" "}
                    <Text>
                        Sofern Sie in die Datenverarbeitung eingewilligt haben, verarbeiten wir Ihre personenbezogenen Daten auf Grundlage von Art. 6
                        Abs. 1 lit. a DSGVO bzw. Art. 9 Abs. 2 lit. a DSGVO, sofern besondere Datenkategorien nach Art. 9 Abs. 1 DSGVO verarbeitet
                        werden. Im Falle einer ausdrücklichen Einwilligung in die Übertragung personenbezogener Daten in Drittstaaten erfolgt die
                        Datenverarbeitung außerdem auf Grundlage von Art. 49 Abs. 1 lit. a DSGVO. Sofern Sie in die Speicherung von Cookies oder in
                        den Zugriff auf Informationen in Ihr Endgerät (z.&nbsp;B. via Device-Fingerprinting) eingewilligt haben, erfolgt die
                        Datenverarbeitung zusätzlich auf Grundlage von § 25 Abs. 1 TDDDG. Die Einwilligung ist jederzeit widerrufbar. Sind Ihre Daten
                        zur Vertragserfüllung oder zur Durchführung vorvertraglicher Maßnahmen erforderlich, verarbeiten wir Ihre Daten auf Grundlage
                        des Art. 6 Abs. 1 lit. b DSGVO. Des Weiteren verarbeiten wir Ihre Daten, sofern diese zur Erfüllung einer rechtlichen
                        Verpflichtung erforderlich sind auf Grundlage von Art. 6 Abs. 1 lit. c DSGVO. Die Datenverarbeitung kann ferner auf Grundlage
                        unseres berechtigten Interesses nach Art. 6 Abs. 1 lit. f DSGVO erfolgen. Über die jeweils im Einzelfall einschlägigen
                        Rechtsgrundlagen wird in den folgenden Absätzen dieser Datenschutzerklärung informiert.
                    </Text>
                    <Heading as="h3" my={3}>
                        Empfänger von personenbezogenen Daten
                    </Heading>{" "}
                    <Text>
                        Im Rahmen unserer Geschäftstätigkeit arbeiten wir mit verschiedenen externen Stellen zusammen. Dabei ist teilweise auch eine
                        Übermittlung von personenbezogenen Daten an diese externen Stellen erforderlich. Wir geben personenbezogene Daten nur dann an
                        externe Stellen weiter, wenn dies im Rahmen einer Vertragserfüllung erforderlich ist, wenn wir gesetzlich hierzu verpflichtet
                        sind (z.&nbsp;B. Weitergabe von Daten an Steuerbehörden), wenn wir ein berechtigtes Interesse nach Art. 6 Abs. 1 lit. f DSGVO
                        an der Weitergabe haben oder wenn eine sonstige Rechtsgrundlage die Datenweitergabe erlaubt. Beim Einsatz von
                        Auftragsverarbeitern geben wir personenbezogene Daten unserer Kunden nur auf Grundlage eines gültigen Vertrags über
                        Auftragsverarbeitung weiter. Im Falle einer gemeinsamen Verarbeitung wird ein Vertrag über gemeinsame Verarbeitung
                        geschlossen.
                    </Text>
                    <Heading as="h3" my={3}>
                        Widerruf Ihrer Einwilligung zur Datenverarbeitung
                    </Heading>{" "}
                    <Text>
                        Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine bereits erteilte
                        Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf
                        unberührt.
                    </Text>
                    <Heading as="h3" my={3}>
                        Widerspruchsrecht gegen die Datenerhebung in besonderen Fällen sowie gegen Direktwerbung (Art. 21 DSGVO)
                    </Heading>{" "}
                    <Text>
                        WENN DIE DATENVERARBEITUNG AUF GRUNDLAGE VON ART. 6 ABS. 1 LIT. E ODER F DSGVO ERFOLGT, HABEN SIE JEDERZEIT DAS RECHT, AUS
                        GRÜNDEN, DIE SICH AUS IHRER BESONDEREN SITUATION ERGEBEN, GEGEN DIE VERARBEITUNG IHRER PERSONENBEZOGENEN DATEN WIDERSPRUCH
                        EINZULEGEN; DIES GILT AUCH FÜR EIN AUF DIESE BESTIMMUNGEN GESTÜTZTES PROFILING. DIE JEWEILIGE RECHTSGRUNDLAGE, AUF DENEN EINE
                        VERARBEITUNG BERUHT, ENTNEHMEN SIE DIESER DATENSCHUTZERKLÄRUNG. WENN SIE WIDERSPRUCH EINLEGEN, WERDEN WIR IHRE BETROFFENEN
                        PERSONENBEZOGENEN DATEN NICHT MEHR VERARBEITEN, ES SEI DENN, WIR KÖNNEN ZWINGENDE SCHUTZWÜRDIGE GRÜNDE FÜR DIE VERARBEITUNG
                        NACHWEISEN, DIE IHRE INTERESSEN, RECHTE UND FREIHEITEN ÜBERWIEGEN ODER DIE VERARBEITUNG DIENT DER GELTENDMACHUNG, AUSÜBUNG
                        ODER VERTEIDIGUNG VON RECHTSANSPRÜCHEN (WIDERSPRUCH NACH ART. 21 ABS. 1 DSGVO).
                    </Text>{" "}
                    <Text>
                        WERDEN IHRE PERSONENBEZOGENEN DATEN VERARBEITET, UM DIREKTWERBUNG ZU BETREIBEN, SO HABEN SIE DAS RECHT, JEDERZEIT WIDERSPRUCH
                        GEGEN DIE VERARBEITUNG SIE BETREFFENDER PERSONENBEZOGENER DATEN ZUM ZWECKE DERARTIGER WERBUNG EINZULEGEN; DIES GILT AUCH FÜR
                        DAS PROFILING, SOWEIT ES MIT SOLCHER DIREKTWERBUNG IN VERBINDUNG STEHT. WENN SIE WIDERSPRECHEN, WERDEN IHRE PERSONENBEZOGENEN
                        DATEN ANSCHLIESSEND NICHT MEHR ZUM ZWECKE DER DIREKTWERBUNG VERWENDET (WIDERSPRUCH NACH ART. 21 ABS. 2 DSGVO).
                    </Text>
                    <Heading as="h3" my={3}>
                        Beschwerde­recht bei der zuständigen Aufsichts­behörde
                    </Heading>{" "}
                    <Text>
                        Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein Beschwerderecht bei einer Aufsichtsbehörde, insbesondere in
                        dem Mitgliedstaat ihres gewöhnlichen Aufenthalts, ihres Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes zu. Das
                        Beschwerderecht besteht unbeschadet anderweitiger verwaltungsrechtlicher oder gerichtlicher Rechtsbehelfe.
                    </Text>
                    <Heading as="h3" my={3}>
                        Recht auf Daten­übertrag­barkeit
                    </Heading>{" "}
                    <Text>
                        Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung eines Vertrags automatisiert
                        verarbeiten, an sich oder an einen Dritten in einem gängigen, maschinenlesbaren Format aushändigen zu lassen. Sofern Sie die
                        direkte Übertragung der Daten an einen anderen Verantwortlichen verlangen, erfolgt dies nur, soweit es technisch machbar ist.
                    </Text>
                    <Heading as="h3" my={3}>
                        Auskunft, Berichtigung und Löschung
                    </Heading>{" "}
                    <Text>
                        Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf unentgeltliche Auskunft über Ihre
                        gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der Datenverarbeitung und ggf. ein Recht auf
                        Berichtigung oder Löschung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema personenbezogene Daten können Sie sich
                        jederzeit an uns wenden.
                    </Text>
                    <Heading as="h3" my={3}>
                        Recht auf Einschränkung der Verarbeitung
                    </Heading>{" "}
                    <Text>
                        Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Hierzu können Sie sich
                        jederzeit an uns wenden. Das Recht auf Einschränkung der Verarbeitung besteht in folgenden Fällen:
                    </Text>{" "}
                    <ul>
                        {" "}
                        <li>
                            Wenn Sie die Richtigkeit Ihrer bei uns gespeicherten personenbezogenen Daten bestreiten, benötigen wir in der Regel Zeit,
                            um dies zu überprüfen. Für die Dauer der Prüfung haben Sie das Recht, die Einschränkung der Verarbeitung Ihrer
                            personenbezogenen Daten zu verlangen.
                        </li>{" "}
                        <li>
                            Wenn die Verarbeitung Ihrer personenbezogenen Daten unrechtmäßig geschah/geschieht, können Sie statt der Löschung die
                            Einschränkung der Datenverarbeitung verlangen.
                        </li>{" "}
                        <li>
                            Wenn wir Ihre personenbezogenen Daten nicht mehr benötigen, Sie sie jedoch zur Ausübung, Verteidigung oder Geltendmachung
                            von Rechtsansprüchen benötigen, haben Sie das Recht, statt der Löschung die Einschränkung der Verarbeitung Ihrer
                            personenbezogenen Daten zu verlangen.
                        </li>{" "}
                        <li>
                            Wenn Sie einen Widerspruch nach Art. 21 Abs. 1 DSGVO eingelegt haben, muss eine Abwägung zwischen Ihren und unseren
                            Interessen vorgenommen werden. Solange noch nicht feststeht, wessen Interessen überwiegen, haben Sie das Recht, die
                            Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
                        </li>{" "}
                    </ul>
                    <Text>
                        Wenn Sie die Verarbeitung Ihrer personenbezogenen Daten eingeschränkt haben, dürfen diese Daten – von ihrer Speicherung
                        abgesehen – nur mit Ihrer Einwilligung oder zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen oder zum
                        Schutz der Rechte einer anderen natürlichen oder juristischen Person oder aus Gründen eines wichtigen öffentlichen Interesses
                        der Europäischen Union oder eines Mitgliedstaats verarbeitet werden.
                    </Text>
                    <Heading as="h3" my={3}>
                        SSL- bzw. TLS-Verschlüsselung
                    </Heading>{" "}
                    <Text>
                        Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte, wie zum Beispiel Bestellungen
                        oder Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung
                        erkennen Sie daran, dass die Adresszeile des Browsers von „http://“ auf „https://“ wechselt und an dem Schloss-Symbol in Ihrer
                        Browserzeile.
                    </Text>{" "}
                    <Text>
                        Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können die Daten, die Sie an uns übermitteln, nicht von Dritten
                        mitgelesen werden.
                    </Text>
                    <Heading as="h3" my={3}>
                        Widerspruch gegen Werbe-E-Mails
                    </Heading>{" "}
                    <Text>
                        Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten zur Übersendung von nicht ausdrücklich
                        angeforderter Werbung und Informationsmaterialien wird hiermit widersprochen. Die Betreiber der Seiten behalten sich
                        ausdrücklich rechtliche Schritte im Falle der unverlangten Zusendung von Werbeinformationen, etwa durch Spam-E-Mails, vor.
                    </Text>
                    <Spacer my={20} />
                    <Heading as="h2" my={3}>
                        4. Datenerfassung auf dieser Website
                    </Heading>
                    <Heading as="h3" my={3}>
                        Server-Log-Dateien
                    </Heading>{" "}
                    <Text>
                        Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log-Dateien, die Ihr Browser
                        automatisch an uns übermittelt. Dies sind:
                    </Text>{" "}
                    <ul>
                        <li>Browsertyp und Browserversion</li> <li>verwendetes Betriebssystem</li> <li>Referrer URL</li>
                        <li>Hostname des zugreifenden Rechners</li> <li>Uhrzeit der Serveranfrage</li> <li>IP-Adresse</li>{" "}
                    </ul>
                    <Text>Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen.</Text>{" "}
                    <Text>
                        Die Erfassung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes
                        Interesse an der technisch fehlerfreien Darstellung und der Optimierung seiner Website – hierzu müssen die Server-Log-Files
                        erfasst werden.
                    </Text>
                    <Heading as="h3" my={3}>
                        Anfrage per E-Mail, Telefon oder Telefax
                    </Heading>{" "}
                    <Text>
                        Wenn Sie uns per E-Mail, Telefon oder Telefax kontaktieren, wird Ihre Anfrage inklusive aller daraus hervorgehenden
                        personenbezogenen Daten (Name, Anfrage) zum Zwecke der Bearbeitung Ihres Anliegens bei uns gespeichert und verarbeitet. Diese
                        Daten geben wir nicht ohne Ihre Einwilligung weiter.
                    </Text>{" "}
                    <Text>
                        Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit der Erfüllung
                        eines Vertrags zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen erforderlich ist. In allen übrigen Fällen beruht
                        die Verarbeitung auf unserem berechtigten Interesse an der effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs.
                        1 lit. f DSGVO) oder auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese abgefragt wurde; die Einwilligung ist
                        jederzeit widerrufbar.
                    </Text>{" "}
                    <Text>
                        Die von Ihnen an uns per Kontaktanfragen übersandten Daten verbleiben bei uns, bis Sie uns zur Löschung auffordern, Ihre
                        Einwilligung zur Speicherung widerrufen oder der Zweck für die Datenspeicherung entfällt (z.&nbsp;B. nach abgeschlossener
                        Bearbeitung Ihres Anliegens). Zwingende gesetzliche Bestimmungen – insbesondere gesetzliche Aufbewahrungsfristen – bleiben
                        unberührt.
                    </Text>
                    <Spacer my={5} />
                    <Text>
                        Quelle:{" "}
                        <Link href="https://www.e-recht24.de" target='_blank' rel='noopener noreferrer'>
                            https://www.e-recht24.de
                        </Link>
                    </Text>
                    <Spacer my={5} />
                </Box>
            </Box>
            <FooterInfo />
        </Flex>
    );
}
